var _path, _path2, _path3, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.7254 71.6979C79.6323 73.1128 78.545 74.2725 76.3095 74.2725H3.96332C1.72775 74.2725 0.640447 73.1146 1.54738 71.6979L7.09566 63.029C8.00259 61.6141 10.5735 60.4543 12.8065 60.4543H67.4637C69.6993 60.4543 72.2702 61.6123 73.1771 63.029L78.7254 71.6979Z",
    fill: "#EDF0F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1889 13.1248C51.8841 8.65622 46.4527 5.08554 40.1348 5.09083C33.817 5.08554 28.3856 8.65622 26.0836 13.1248C23.6408 17.6014 24.3247 23.7207 27.0263 30.5266C29.7308 37.3273 33.3217 42.8866 35.618 47.5507C38.0495 52.2042 39.1864 55.2176 40.1348 55.2044C41.086 55.2176 42.2229 52.2042 44.6544 47.5507C46.9508 42.884 50.5417 37.3273 53.2461 30.5266C55.9478 23.7207 56.6344 17.6014 54.1889 13.1248Z",
    fill: "url(#paint0_linear_4189_15465)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3556 19.0539C46.3556 22.5594 43.501 25.4028 39.9757 25.4028C36.4504 25.4028 33.5958 22.5621 33.5958 19.0539C33.5958 15.5458 36.4504 12.7078 39.9757 12.7078C43.501 12.7078 46.3556 15.5485 46.3556 19.0539Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.2272,
    cy: 67.3131,
    rx: 6.78893,
    ry: 1.41414,
    fill: "#8595A8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4189_15465",
    x1: 40.1368,
    y1: 5.09082,
    x2: 39.9204,
    y2: 41.6463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8AD",
    stopOpacity: 0.78
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressMap);
export default __webpack_public_path__ + "static/media/address-map.2322912cbb3fd35dda6c59da44bc65db.svg";
export { ForwardRef as ReactComponent };